const styles = {
  searchGrid: {
    margin: '0 auto !important',
    width: '100% !important',
  },
  cardContainer: {
    borderRadius: '.42857em !important',
    boxShadow: 'none !important',
  },
  cardContent: { padding: '.5625rem !important' },
  searchGroup: {
    backgroundColor: '#fafafa !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    margin: '0 !important',
    width: '100%',
  },
  searchText: {
    margin: '.25rem 0 !important',
    padding: '0 !important',
    width: '100%',
    fontSize: '.875rem !important',
    '@global .ui.input': {
      '&::placeholder': {
        color: '#646464 !important',
        opacity: 1,
      },
      '& input': {
        border: 'none !important',
        backgroundColor: '#fafafa !important',
        paddingTop: '.5rem !important',
        paddingBottom: '.5rem !important',
      },
    },
  },
  button: {
    backgroundColor: '#683caf !important',
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.875rem',
    margin: '.25rem 0 !important',
    opacity: 1,
    padding: '.5625rem 1.5em .5625rem !important',
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  '@global .ui.disabled.button ': {
    backgroundColor: '#d8dee1 !important',
    opacity: '1 !important',
  },
  selectSearchBy: {
    width: '12rem',
  },
  filters: {
    '@global .dropdown': {
      whiteSpace: 'nowrap !important',
    },
    '@global .dropdown .menu': {
      width: 'auto !important',
    },
    '@global .dropdown .menu > .item': {
      whiteSpace: 'nowrap !important',
      padding: '.78571429rem 1rem !important',
    },
  },
};

export default styles;
